@if (operand) {
  <em-operand-icon [operand]="operand" [isCustom]="isCustom"></em-operand-icon>
  <em-operand-label [operand]="operand"></em-operand-label>
}
